module.exports = __webpack_public_path__ + "static/img/img1.10bf3094.png";